import { render, staticRenderFns } from "./TypDog.vue?vue&type=template&id=0137bd2b&"
import script from "./TypDog.vue?vue&type=script&lang=js&"
export * from "./TypDog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports